module.exports = __webpack_public_path__ + "static/media/3.f7bfccfb.svg";